import { formatCurrency } from '../../lib/utils';
import type { InventoryMovementMode } from '../../hooks/useInventoryMovementMode';
import type { InventorySnippetMetrics } from '../../hooks/useInventorySnippetData';
import {
  ControlCentreMetricCard,
  ControlCentreMetricsGrid,
  ControlCentreMetricsRow,
} from './ControlCentreMetricCard';

interface InventoryHeaderMetricsProps {
  metrics: InventorySnippetMetrics;
  movementMode: InventoryMovementMode;
  loading?: boolean;
}

function primaryMetricDisplay(
  movementMode: InventoryMovementMode,
  metrics: InventorySnippetMetrics
): { title: string; mobileTitle: string; value: string } {
  if (movementMode === 'consumed') {
    return {
      title: 'Consumed',
      mobileTitle: 'Consumed',
      value: String(metrics.consumedUnitsThisMonth),
    };
  }

  return {
    title: 'Sales',
    mobileTitle: 'Sales',
    value: formatCurrency(metrics.salesThisMonth),
  };
}

/** Inventory counts in the control-centre panel header. */
export default function InventoryHeaderMetrics({
  metrics,
  movementMode,
  loading = false,
}: InventoryHeaderMetricsProps) {
  const primary = primaryMetricDisplay(movementMode, metrics);

  const primaryCard = (
    <ControlCentreMetricCard
      title={primary.title}
      mobileTitle={primary.mobileTitle}
      value={primary.value}
      loading={loading}
    />
  );

  const valueCard = (
    <ControlCentreMetricCard
      title="Inventory value"
      mobileTitle="Value"
      value={formatCurrency(metrics.totalValue)}
      loading={loading}
    />
  );

  const gridPrimary = (
    <ControlCentreMetricCard
      title={primary.title}
      mobileTitle={primary.mobileTitle}
      value={primary.value}
      loading={loading}
      layout="grid"
    />
  );

  const gridValue = (
    <ControlCentreMetricCard
      title="Inventory value"
      mobileTitle="Value"
      value={formatCurrency(metrics.totalValue)}
      loading={loading}
      layout="grid"
    />
  );

  return (
    <div className="w-full min-w-0">
      <div className="sm:hidden">
        <ControlCentreMetricsGrid>
          {gridPrimary}
          {gridValue}
        </ControlCentreMetricsGrid>
      </div>

      <div className="hidden sm:block w-full min-w-0">
        <ControlCentreMetricsRow>
          {primaryCard}
          {valueCard}
        </ControlCentreMetricsRow>
      </div>
    </div>
  );
}
